module.exports = __webpack_public_path__ + "img/elstic.e3d481fe.png";